import React, {
  useEffect,
  useState,
} from 'react';

import addColDurations from './utils/addColDurations';

import GanttGrid from './GanttGrid';
import GanttBars from './GanttBars';
import GanttArrows from './GanttArrows.v1';

const GanttBody = ({
  dateMode,
  onBarsDragged,
  onBarsClicked,
  hasSizeControls,
  areBarsDraggable,
  colSize,
  colCount,
  colOffset,
  arrowBodyStyle,
  arrowBodyDashArray,
  arrowHeadStyle,
  arrowHeadDashArray,
  barData,
  setBarData,
  onBarClick,
  onBarMove,
}) => {
  const [isMouseMoving, setIsMouseMoving] = useState(false);
  const [isMouseDown, setIsMouseDown] = useState(false);
  const [mouseOnMovePos, setMouseOnMovePos] = useState({});
  const [mouseOnStartData, setMouseOnStartData] = useState({});
  const [barOptions, setBarOptions] = useState({
    barHeight: 18,
  }); 
  
  const moveThreshold = 2;
  
  const mousePosDelta = (e, pos) => ({
    x: e.pageX - pos.x,
    y: e.pageY - pos.y,
  });
  const mouseMovePosDelta = (e) => mousePosDelta(e, mouseOnMovePos);
  const mouseStartPosDelta = (e) => mousePosDelta(e, mouseOnStartData);
  
  const mouseDistDelta = (e, pos) => Math.sqrt(
    Math.pow(e.pageX - pos.x, 2) + 
    Math.pow(e.pageY - pos.y, 2)
  );
  const mouseMoveDistDelta = (e) => mouseDistDelta(e, mouseOnMovePos);
  const mouseStartDistDelta = (e) => mouseDistDelta(e, mouseOnStartData);
  
  const onBarMouseDown = (e) => {
    setIsMouseDown(true);
    
    const { target, pageX, pageY } = e;
    const idx = target.getAttribute('data-index');
    
    setMouseOnMovePos({
      idx: target.getAttribute('data-index'),
      x: pageX,
      y: pageY,
    });
    setMouseOnStartData({
      bar: barData[idx],
      x: pageX,
      y: pageY,
    });
  };
  const onBarMouseExit = (e) => {
    if (!isMouseMoving && isMouseDown) {
      onBarClick(e.target);
    }
    
    setIsMouseDown(false);
    setIsMouseMoving(false);
    setMouseOnMovePos({});
    setMouseOnStartData({});
  };
  const onBarMouseMove = (e) => {
    const moveDelta = mouseMoveDistDelta(e);
    
    if (isMouseDown && mouseOnStartData.bar && moveDelta >= moveThreshold) {
      if (isMouseMoving) setIsMouseMoving(true);
      
      const { pageX, pageY } = e; 
      setMouseOnMovePos(prev => ({
        ...prev,
        x: pageX,
        y: pageY,
      }));
      
      const offsetSize = Math.round(mouseStartPosDelta(e).x / colSize);
      
      const { start, end, idx, deps } = mouseOnStartData.bar;
      const updatedBar = {
        ...mouseOnStartData.bar,
        start: addColDurations(start, dateMode, offsetSize),
        end: addColDurations(end, dateMode, offsetSize),
      };
      
      // For each deps
      //   Disallow past start if depEnforcement === begun
      //   Disallow past end if depEnforcement === ended
      //   Move in tandem if linked
      
      
      const updatedBarData = [...barData];
      updatedBarData[idx] = updatedBar;
      
      setBarData(updatedBarData);
    }
  };

  return (
    <svg
      id="gantt-body"
      onMouseDown={onBarMouseDown}
      onMouseUp={onBarMouseExit}
      onMouseLeave={onBarMouseExit}
      onMouseMove={onBarMouseMove}
    >
      <GanttGrid
        onBarsDragged={onBarsDragged}
        onBarsClicked={onBarsClicked}
        hasSizeControls={hasSizeControls}
        areBarsDraggable={areBarsDraggable}
        colSize={colSize}
        colCount={colCount}
        colOffset={colOffset}
        barCount={barData && barData.length}
      />
      <GanttArrows
        dateMode={dateMode}
        colSize={colSize}
        colCount={colCount}
        colOffset={colOffset}
        barOptions={barOptions}
        barData={barData}
      />
      <GanttBars
        dateMode={dateMode}
        colSize={colSize}
        colCount={colCount}
        colOffset={colOffset}
        barOptions={barOptions}
        barData={barData}
        onBarClick={onBarClick}
        onBarMove={onBarMove}
      />
    </svg>
  );
};

export default GanttBody;
